// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conflicto-sesion-container {
  max-width: 1000px;
  margin: 2rem auto;
  padding: 1rem;
}

.gap-2 {
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/conflicto-sesion/conflicto-sesion.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,iBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".conflicto-sesion-container {\n  max-width: 1000px;\n  margin: 2rem auto;\n  padding: 1rem;\n}\n\n.gap-2 {\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
